import API from '../helpers/api';

export function logout() {
	return async dispatch => {
		const res = await API.auth.logout();
		localStorage.removeItem('ldr_student');
		if (res.meta.code !== 200) {
			console.log('error', res);
			return;
		}
		window.location.href = res.data.logout_url;
	};
}
